import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as firebase from 'firebase';
import 'firebase/firestore';
import {Expo} from 'vexpo-components';
import './index.css';
import registerServiceWorker from './registerServiceWorker';

var config = {
   apiKey: "AIzaSyCTpN_wbiDc3E0WAeZDCqah9EOFcouL72A",
   authDomain: "north-american-sportshow.firebaseapp.com",
   databaseURL: "https://north-american-sportshow.firebaseio.com",
   projectId: "north-american-sportshow",
   storageBucket: "north-american-sportshow.appspot.com",
   messagingSenderId: "20579902729"
};
firebase.initializeApp(config);

var db = firebase.firestore();

var expoRef = db.collection('expos').doc('north-american-sportshow');
expoRef.get().then(doc => {
  if(doc.exists) {
    const current = doc.data().current;
    var releaseRef = expoRef.collection('releases').doc(current);
    releaseRef.get().then(doc => {
      if(doc.exists) {
        var expo = doc.data();
        ReactDOM.render(<Expo {...expo} firebase={firebase} />, document.getElementById('root'));
      }
    });
  }
});


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js